import GeographicLocationPage from './GeographicLocationPage'

export default GeographicLocationPage